import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { Box, Container, FormControl, MenuItem, Select } from '@material-ui/core';
import styled from 'styled-components';
import {
    AppDashboardSplitType,
    useAppOrgQuery,
    useGetAppDashboardQuery,
} from '../../../types/generated';
import { ExtranetHomeDashboard } from './ExtranetHomeDashboard';
import { Options } from './ChartComponents/ChartOptions';
import { useUser } from '../../../utils/user';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Link } from 'react-router-dom';

const DashboardFilter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 24px 0;
    font-weight: bold;
    color: ${props => props.theme.primary};
`;

export function ExtranetHome() {
    const [to] = useState<Date>(new Date());
    const user = useUser();

    const { data: orgData } = useAppOrgQuery({ variables: { id: user.orgId } });
    const org = orgData && orgData.appOrg;
    const [selectedOption, setSelectedOption] = useState<(typeof Options)[1]>(Options[1]);
    // Read from the selectedOption
    const [split, setSplit] = useState<AppDashboardSplitType>(
        selectedOption.availableSplitTypes[0]
    );
    const [from, setFrom] = useState<Date>(selectedOption.from);

    const { data, loading } = useGetAppDashboardQuery({
        variables: {
            timestampFrom: from.getTime(),
            timestampTo: to.getTime(),
            split,
        },
    });

    const updateDates = (o: React.ChangeEvent<{ name?: string; value: number }>) => {
        const option = Options.find(opt => opt.value === o.target.value);

        // Update the state
        setSelectedOption(option);
        setSplit(option.availableSplitTypes[0]);
        setFrom(option.from);
    };

    return (
        <React.Fragment>
            <Container>
                {org && (!org.termsApiAgreed || !org.termsPartnerAgreed) && (
                    <Box mb={2}>
                        <Alert severity={'warning'}>
                            <AlertTitle>Attention!</AlertTitle>
                            Before being able to publish your apps you will have to agree to our API
                            and Partner terms. To read and accept the terms you can head over to the{' '}
                            <Link to={'/extranet/account'}>Account settings</Link> page.
                        </Alert>
                    </Box>
                )}
                <Typography gutterBottom variant="h5" component="h1">
                    Reports overview
                </Typography>
                <DashboardFilter>
                    <div>
                        <FormControl>
                            <Select
                                labelId={'date-selection'}
                                value={selectedOption.value}
                                onChange={(
                                    o: React.ChangeEvent<{ name?: string; value: number }>
                                ) => updateDates(o)}
                            >
                                {Options.map((o, oIndex) => (
                                    <MenuItem key={oIndex} value={o.value}>
                                        {o.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl>
                            <Select
                                labelId={'date-selection'}
                                value={split}
                                onChange={(
                                    o: React.ChangeEvent<{
                                        name?: string;
                                        value: AppDashboardSplitType;
                                    }>
                                ) => setSplit(o.target.value)}
                            >
                                {selectedOption.availableSplitTypes.map((o, oIndex) => (
                                    <MenuItem key={oIndex} value={o.toUpperCase()}>
                                        {o}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </DashboardFilter>
                {loading ? (
                    <p>Loading</p>
                ) : (
                    <ExtranetHomeDashboard
                        from={from}
                        to={to}
                        data={data?.AppDashboardQuery}
                        split={split}
                    />
                )}
            </Container>
        </React.Fragment>
    );
}
